import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=be1f18bc&"
import script from "./breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffunday%2Ffunday%2Ffrontend%2Fsrc%2Fcomponents%2Fbreadcrumbs%2Fbreadcrumbs.vue"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be1f18bc')) {
      api.createRecord('be1f18bc', component.options)
    } else {
      api.reload('be1f18bc', component.options)
    }
    module.hot.accept("./breadcrumbs.vue?vue&type=template&id=be1f18bc&", function () {
      api.rerender('be1f18bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/breadcrumbs/breadcrumbs.vue"
export default component.exports